<div class="py-3" [class.wait]="wait">
    <div class="align-center h-100">
        <div class="text-center">
            <p class="title"><b>cargando...</b></p>
            <p class="subtitle mb-1">por favor espere</p>
            <img src="assets/img/intern/icons/status/loading.svg" alt="loading" class="icon spin">
        </div>
    </div>
</div>